/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_USER_PROFILE = '[Account] Get User Profile',
  GET_USER_PROFILE_SUCCESS = '[Account] Get User Profile Success',
  GET_USER_PROFILE_FAILED = '[Account] Get User Profile Failed',

  GET_SCORERS = '[Account] Get Scorers',
  GET_SCORERS_SUCCESS = '[Account] Get Scorers Success',
  GET_SCORERS_FAILED = '[Account] Get Scorers Failed',

  CREATE_SCORERS = '[Account] Create Scorers',
  CREATE_SCORERS_SUCCESS = '[Account] Create Scorers Success',
  CREATE_SCORERS_FAILED = '[Account] Create Scorers Failed',

  GET_PLAYERS = '[Account] Get Players',
  GET_PLAYERS_SUCCESS = '[Account] Get Players Success',
  GET_PLAYERS_FAILED = '[Account] Get Players Failed',

  CREATE_PLAYERS = '[Account] Create Players',
  CREATE_PLAYERS_SUCCESS = '[Account] Create Players Success',
  CREATE_PLAYERS_FAILED = '[Account] Create Players Failed',
}

export const getUserProfileSuccess = createAction(
  ActionTypes.GET_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const getUserProfileFailed = createAction(
	ActionTypes.GET_USER_PROFILE_FAILED,
  props<{ data: any }>()
);

export const getScorers = createAction(
  ActionTypes.GET_SCORERS
);

export const getScorersSuccess = createAction(
	ActionTypes.GET_SCORERS_SUCCESS,
  props<{ data: any }>()
);

export const getScorersFailed = createAction(
  ActionTypes.GET_SCORERS_FAILED,
  props<{ data: any }>()
);

export const createScorers = createAction(
  ActionTypes.CREATE_SCORERS,
  props<{ data: any }>()
);

export const createScorersSuccess = createAction(
	ActionTypes.CREATE_SCORERS_SUCCESS,
  props<{ data: any }>()
);

export const createScorersFailed = createAction(
  ActionTypes.CREATE_SCORERS_FAILED,
  props<{ data: any }>()
);

export const getPlayers = createAction(
  ActionTypes.GET_PLAYERS
);

export const getPlayersSuccess = createAction(
	ActionTypes.GET_PLAYERS_SUCCESS,
  props<{ data: any }>()
);

export const getUserProfile = createAction(
  ActionTypes.GET_USER_PROFILE,
  props<{ data: any }>()
);

export const createPlayers = createAction(
  ActionTypes.CREATE_PLAYERS,
  props<{ data: any }>()
);

export const createPlayersSuccess = createAction(
	ActionTypes.CREATE_PLAYERS_SUCCESS,
  props<{ data: any }>()
);

export const createPlayersFailed = createAction(
  ActionTypes.CREATE_PLAYERS_FAILED,
  props<{ data: any }>()
);